import React, { useRef, Suspense } from "react";
import PropTypes from "prop-types";
import s from "./DropdownList.module.css";

import Each from "../utils/Each.tsx";
import { useOnClickOutside } from "usehooks-ts";

export type DropdownListProps = {
    list: any[];
    onClick: (e: any) => void;
};

export default function DropdownList({ list, onClick }: DropdownListProps) {
    const listRef = useRef(null);

    useOnClickOutside(listRef, () => onClick("outsideclick"));

    return (
        <Suspense fallback={<div>Loading...</div>}>
            <ul className={s.suggestionDropdown}
                ref={listRef}>
                <Each
                    of={list}
                    render={(item) => (
                        <li
                            className={s.suggestionDropdownItem}
                            tabIndex={0}
                            onClick={onClick}
                        >
                            {item.value}
                        </li>
                    )}
                />
            </ul>
        </Suspense>
    );
}

DropdownList.propTypes = {
    list: PropTypes.array,
    className: PropTypes.string,
    onClick: PropTypes.func,
};
